window.app.controller('reportCtrl', ['$scope', '$http', function ($scope, $http) {

    $scope.attributTitle = "selectAllattributes";
    $scope.offers;
    $scope.offerId = "selectAllProducts";
    $scope.allOffersIds = [];
    $scope.products;
    $scope.trafficSource =  "racoonWebSite";
    $scope.creationTime = "thisMonth";
    $scope.groupedBy = "date";
    $scope.dataPoints = [];
    $scope.tableData = [];
    $scope.total = 0;
    $scope.tableFilteredByLabel = false;
    $scope.tableFilteredByOutcklicks = false;
    $scope.partnerHasLeads = true;
    $scope.dataForXMLExport = [];
    $scope.cpTypes = [];
    $scope.showConvRange = false;
    $scope.postBackTbl = [];
    $scope.partnerHasOffers = false;
    $scope.periodStart;
    $scope.periodEnd;
    $scope.AllRepModels = [];
    $scope.selectedRepModel;
    $scope.totalComission = 0;
    $scope.sortReverse = false;
    $scope.sortType = "filterDate"

    $scope.constructorAttributes = [
        {
          title: 'Chwilówki (spłata na koniec)', 
          filters: {
            "endRepayment": true,
            "freeFirstLoan": false,
            "inFewPayments": false,
            "all": false
          }
        },
        {
          title: 'Chwilówki (spłata na koniec) ZA DARMO',
          filters: {
            "endRepayment": true,
            "freeFirstLoan": true,
            "inFewPayments": false,
            "all": false
          }
        },
        {
          title: 'Pożyczki na raty',
          filters: {
            "endRepayment": false,
            "freeFirstLoan": false,
            "inFewPayments": true,
            "all": false
          }
        },
        {
          title: 'Pożyczki na raty ZA DARMO',
          filters: {
            "endRepayment": false,
            "freeFirstLoan": true,
            "inFewPayments": true,
            "all": false
          }
        }
      ];
      
    $scope.raportFilters = {
        id: "",
        timeUnit: "day",
        periodStart: "",
        periodEnd: "",
        attributes: {
            "endRepayment": false,
            "freeFirstLoan": false,
            "inFewPayments": false,
            "all": true
        },
        offersId : []
    }

    $scope.constructAtrributes = () => {
        if ($scope.attributTitle === "selectAllattributes") {
            $scope.raportFilters.attributes = {
                "endRepayment": false,
                "freeFirstLoan": false,
                "inFewPayments": false,
                "all": true
            };
        } else {
            $scope.constructorAttributes.forEach(function(element){
                if (element.title.toUpperCase() == $scope.attributTitle.toUpperCase()){
                    $scope.raportFilters.attributes = element.filters;
                } 
            })
        }
        $scope.sendInfo("offers-request", {"id": $scope.raportFilters.id,"attributes": $scope.raportFilters.attributes}, $scope.getOffers);
    }

    $scope.timePeriods = {
        "customDate": 'genereteDate',
        "today": 'genereteDate',
        "yesterday": 'setYesterday',
        "thisWeek": 'setThisWeek',
        "previousWeek": 'setPreviousWeek',
        "thisMonth": 'setThisMonth',
        "previousMonth": 'setPreviousMonth',
        "lastThreeMonth": 'setMonthPeriod',
        "lastSixMonth": 'setMonthPeriod'    
        }

    $scope.setTimePeriod = () => {
        for (let period in $scope.timePeriods) {
            if($scope.creationTime == period) {
                $scope.setCurrentDate();
                $scope[$scope.timePeriods[period]]();
                $scope.genereteDate();
            }
        }

        $scope.getAnalyticData();
        // $scope.changeChartIntervalX();
    }

    $scope.genereteDate = () => {
        $scope.periodStart = $scope.start.toLocaleDateString('en-GB');
        $scope.raportFilters.periodStart = $scope.convertDate($scope.periodStart, "/");
        if($scope.creationTime == "yesterday") {
            $scope.periodEnd = $scope.periodStart
        } else {
            $scope.periodEnd = $scope.end.toLocaleDateString('en-GB');
            $scope.raportFilters.periodEnd = $scope.convertDate($scope.periodEnd, "/");
        }
    }

    $scope.setCurrentDate = () => {
        $scope.start = new Date();
        $scope.end = new Date();
        $scope.currentDay = $scope.start.getDay();
    }

    $scope.setYesterday = () => {
        $scope.start.setDate($scope.start.getDate() - 1);
    }

    $scope.setThisWeek = () => { 
        let distance = 1 - $scope.currentDay;
        $scope.start.setDate($scope.start.getDate() + distance);
    }

    $scope.setPreviousWeek = () => {
        $scope.end.setDate($scope.end.getDate() - $scope.currentDay);
        $scope.start.setDate($scope.end.getDate() - 6);
    }

    $scope.setThisMonth = () => {
        $scope.start.setDate(1);
    }

    $scope.setPreviousMonth = () => {
        $scope.start.setMonth($scope.start.getMonth() - 1);
        $scope.start.setDate(1);
        $scope.end.setDate(0);
    }

    $scope.setMonthPeriod = () => {
        let numberOfMonth = 6;
        if($scope.creationTime == "lastThreeMonth") {
            numberOfMonth = 3
        }
        $scope.start.setMonth($scope.start.getMonth() - numberOfMonth);
        $scope.start.setDate(1);
        $scope.end.setDate(0);
    }

    $scope.setCustomPeriod = () => {
        $scope.creationTime = "customDate";
        $scope.raportFilters.periodStart = $scope.convertDate($scope.periodStart, "/");
        $scope.raportFilters.periodEnd = $scope.convertDate($scope.periodEnd, "/");
        $scope.getAnalyticData();
    }

    $( function() {
        $( "#startDatePicker" ).datepicker({ dateFormat: 'dd/mm/yy' });
        $( "#endDatePicker" ).datepicker({ dateFormat: 'dd/mm/yy' });
    });


    $scope.createChart = (resp) => {
        $scope.setChartInterval(resp.data);
        $scope.dataForXMLExport = [];
        if (resp.data.length > 0) {
            $scope.partnerHasLeads = true;
            $scope.dataPoints = [];
            $scope.total = 0;
            if ($scope.groupedBy == 'date') {
                $scope.setWidthToReportsCtn($("#analytic-chart"));
                $scope.changeDisplayedChart( document.getElementById("analytic-chart"), document.getElementById("analytic-offer-chart")); 
                $scope.createDateChart(resp.data);
                $scope.tableData = $scope.dataPoints.slice();
                $scope.getPostBackDataByDate();
                $scope.raportFilters.timeUnit === "day" ? $scope.saveFilterParamToTable($scope.tableData, "-", "label") : "";
                $scope.raportFilters.timeUnit === "week" ? $scope.saveFilterParamToTable($scope.tableData, "-", "flter") : "";
            } else if ($scope.groupedBy == 'offer') {
                $scope.setWidthToReportsCtn($("#analytic-offer-chart")); 
                $scope.changeDisplayedChart( document.getElementById("analytic-offer-chart"), document.getElementById("analytic-chart"));      
                $scope.createOfferChart(resp.data);
                $scope.tableData = $scope.dataPoints.slice();
                // $scope.getPostBackDataByOffers($scope.raportFilters.offersId);
                $scope.getPostBackDataByOffers();
            }
        } else {
            $scope.partnerHasLeads = false;
        }
    }

    $scope.saveFilterParamToTable = (table, splitSymbol, param) => {
        if (param == "label") {
            table.forEach((element) => {
                element.filterDate = new Date(element[param]);
                element[param] = $scope.convertDate(element[param], splitSymbol);
            })
        } else {
            table.forEach((element) => {
                element.filterDate = new Date($scope.convertDate(element[param], splitSymbol));
            })
        }
    }

    $scope.convertDate = (convDate, splitSymbol) => {
        let date = convDate;
        date = date.split(splitSymbol);
        let day = date[1];
        let month = date[0];
        date[0] = day;
        date[1] = month;
        date = date.join(splitSymbol);
        return date;
      }

    $scope.setChartInterval = (chartData) => {
        if (chartData.length < 7) {
            $scope.chartByDate.options.axisX.interval = 1
        } else {
            $scope.chartByDate.options.axisX.interval = null
        }
    }


    $scope.chartByDate = new CanvasJS.Chart("analytic-chart", {
        animationEnabled: true,
        toolTip: {
            borderColor: '#ebeced',
            shared: true,
        },
        axisY:{
            gridThickness: 0.5,
            lineThickness: 0.5,
            interval: null
        },
        axisX:{
            title: "analytic chart",
            titleWrap: true,
            titleFontColor: "#FFFFFF",
            // interval: null,
            intervalType: "day",
            labelAutoFit: true,
            valueFormatString: "DD-MM-YYYY",
            lineThickness: 0.5,
        },
        data: [{ 
            xValueFormatString: "DD-MM-YYYY",       
            type: "spline",  
            name: "Łączny",        
            dataPoints: $scope.dataPoints
        }]
    });

    class charPoint {
        constructor(x, y, label) {
            this.x = x;
            this.y = y;
            this.label = label;
        }
    }

    $scope.modifyXPoints = (data) => {
        if ($scope.raportFilters.timeUnit === "day") {
            let chartDatePoint = new charPoint(new Date(data.date), +data.count, data.date);
            $scope.chartByDate.options.data[0].xValueFormatString = "DD-MM-YYYY";
            return chartDatePoint
        }
        else if ($scope.raportFilters.timeUnit === "month") {
            let x = new Date(data.date.slice(3) + ", " + data.date.slice(0, 2) + ", 1");
            let chartDatePoint = new charPoint(x, +data.count, data.date);
            $scope.chartByDate.options.data[0].xValueFormatString = "MM-YYYY"
            return chartDatePoint
        }
    }

    $scope.modifyChartOptions = () => {
        if ($scope.raportFilters.timeUnit === "day") {
            $scope.chartByDate.options.axisX.labelFormatter = function(e) {
            return CanvasJS.formatDate(e.value, "DD-MM-YYYY");
            }
            // $scope.chartByDate.options.axisX.intervalType = "day"
            $scope.chartByDate.options.data[0].xValueFormatString = "DD-MM-YYYY";
        }
        if ($scope.raportFilters.timeUnit === "month") {
            $scope.chartByDate.options.axisX.labelFormatter = function(e) {
                return CanvasJS.formatDate(e.value, "MM-YYYY");
            }
            // $scope.chartByDate.options.axisX.intervalType = "month"
            $scope.chartByDate.options.data[0].xValueFormatString = "MM-YYYY";
        }
    }

    $scope.createDateChart = (data) => {
        if ($scope.raportFilters.timeUnit === "week") {
            $scope.createWeekChart(data);
        } else {
            $scope.getChartPoints(data, "date");
            $scope.chartByDate.options.data[0].dataPoints = $scope.dataPoints;
            $scope.getDistinctData(data);
            $scope.modifyChartOptions();
            // $scope.changeChartIntervalX();
            $scope.chartByDate.render();  
        }
    }
    
    CanvasJS.addColorSet("racoonShades",
    [
        "#E17C25",
        "#005298",
        "#F1CB32",
        "#7995F3",
        "#D0D2DA",
        "#30D057"              
    ]);

    $scope.createOfferChart = (data) => {
        $scope.getChartPoints(data, "id", "title");
        $scope.dataPoints.forEach(function(element){
            element.label = element.label.toLowerCase().replace(/\b\w/g, l => l.toUpperCase());
        })
        var chart = new CanvasJS.Chart("analytic-offer-chart", {
            animationEnabled: true,
            colorSet: "racoonShades",
            data: [{
                type: "doughnut",
                startAngle: 60,
                indexLabelFontSize: 17,
                indexLabel: "{label} - #percent%",
                toolTipContent: "<b>{label}:</b> {y} (#percent%)",
                dataPoints: $scope.dataPoints
            }]
        });
        chart.render();     
    }
    
    $scope.getChartPoints = (data, prop, name="date") => {
        
        const distinctData = [...new Set(data.map(element => element[prop]))];
        for (let i = 0; i < distinctData.length; i++) {
            let charPoint = {
                y: 0,
                allCount: 0,
            };
            for (let j = 0; j < data.length; j++) {
                if (distinctData[i] === data[j][prop]) { 
                    if ($scope.raportFilters.timeUnit === "day") {
                        charPoint.x = new Date(data[j].date);
                    }
                    if ($scope.raportFilters.timeUnit === "month") {
                        charPoint.x = new Date(data[j].date.slice(3) + ", " + data[j].date.slice(0, 2) + ", 1");
                        $scope.chartByDate.options.data[0].xValueFormatString = "MM-YYYY";
                    }   
                    charPoint.id = data[j][prop];
                    charPoint.label = data[j][name];
                    charPoint.y = charPoint.y + +data[j].count;
                    charPoint.allCount = charPoint.allCount + +data[j].allCount;
                    $scope.notUniqueTotal += +data[j].allCount;
                    $scope.total += +data[j].count;
                }
            }
            $scope.dataPoints.push(charPoint);
        }
    }

    $scope.getDistinctData = (data) => {
        let name;
        const distinctData = [...new Set(data.map(x => x.id))];
        for (let i = 0; i < distinctData.length; i++) {
            let distinctdataPoints = [];
            for (let j = 0; j < data.length; j++) {
                if (distinctData[i] == data[j].id) {
                    let chartDatePoint = $scope.modifyXPoints(data[j]);
                    name = data[j].title;
                    distinctdataPoints.push(chartDatePoint);
                }
            }
            let oneLine = {        
                type: "spline",  
                name: name,
                visible: false,      
                dataPoints: distinctdataPoints
            }
            $scope.chartByDate.options.data.push(oneLine);
        }
    }

    //Referral
    $scope.getReferralData = () => {
        $scope.totalRefTable = {};
        let dataToPass = $scope.prepareRequestData();
        dataToPass.id = $scope.raportFilters.id;
        delete dataToPass.offerId;
        $scope.sendInfo("referral-request/execute", dataToPass, $scope.createReferralTable);
        $scope.sendInfo("referral-request/chart", dataToPass, $scope.createReferralChart);
    }

    $scope.calcTotalForRefTable = (data) => {
        $scope.totalRefTable = data.reduce((a, b) => ({count: +a.count + +b.count,
                                                       lead: +a.lead + +b.lead,
                                                       income: +a.income + +b.income}));
    }

    $scope.createReferralTable = (resp) => {
        $scope.calcTotalForRefTable(resp.data.mainTable);
        ($scope.totalRefTable.count == 0 && $scope.totalRefTable.lead == 0) ? $scope.partnerHasReferral = false :  $scope.partnerHasReferral = true;
        $scope.referralTable = resp.data.mainTable;
        $scope.saveFilterParamToTable($scope.referralTable, "-", "date")
        // $scope.referralTable.forEach((element) => {
        //     element.filterDate = $scope.convertDate(element.date, "-");
        // })
        $scope.raferralIncomeTD = resp.data.additionalTable;
    }

    $scope.createReferralChart = (resp) => {
        $scope.setChartInterval(resp.data);
        $scope.dataPoints = [];
        if (resp.data) {
            $scope.partnerHasLeads = true;
            $scope.partnerHasOffers = true;
            $scope.changeDisplayedChart(document.getElementById("analytic-chart"), document.getElementById("analytic-offer-chart"));
            let smsChart = [];
            let emailChart = [];
            let referralChart = [];
            let raportChart = [];
            let bikfishChart = [];
            for (let oneDate in resp.data) {
                resp.data[oneDate].date = $scope.convertDate(resp.data[oneDate].date, "-");
                var chartDatePoint = $scope.modifyXPoints(resp.data[oneDate]);
                if (resp.data[oneDate].sms) {
                    let smsChartPoint = Object.assign({}, chartDatePoint);
                    smsChartPoint.y = resp.data[oneDate].sms;
                    smsChart.push(smsChartPoint);   
                }
                if (resp.data[oneDate].email) {
                    let emailChartPoint = Object.assign({}, chartDatePoint);
                    emailChartPoint.y = resp.data[oneDate].email;
                    emailChart.push(emailChartPoint);   
                }
                if (resp.data[oneDate].referral) {
                    let referralChartPoint = Object.assign({}, chartDatePoint);
                    referralChartPoint.y = resp.data[oneDate].referral;
                    referralChart.push(referralChartPoint);   
                }
                if (resp.data[oneDate].raport) {
                    let raportChartPoint = Object.assign({}, chartDatePoint);
                    raportChartPoint.y = resp.data[oneDate].raport;
                    raportChart.push(raportChartPoint);   
                }
                if (resp.data[oneDate].bikfish) {
                    let bikfishChartPoint = Object.assign({}, chartDatePoint);
                    bikfishChartPoint.y = resp.data[oneDate].bikfish;
                    bikfishChart.push(bikfishChartPoint);   
                }
                $scope.dataPoints.push(chartDatePoint);
            }
            $scope.getUtmChartPoints(smsChart, "sms");
            $scope.getUtmChartPoints(emailChart, "email");
            $scope.getUtmChartPoints(referralChart, "referral");
            $scope.getUtmChartPoints(raportChart, "raport");
            $scope.getUtmChartPoints(bikfishChart, "bikfish");
            $scope.chartByDate.options.data[0].dataPoints = $scope.dataPoints;
            $scope.modifyChartOptions();
            $scope.chartByDate.render();
        } else {
            $scope.partnerHasLeads = false;
            $scope.partnerHasOffers = false;
        }
    }

    // $scope.createRefWeekChart = (data) => {
    //     for (let oneDate in data) {
    //         var charPoint = {
    //             y: 0,
    //         };
    //         let date = data[oneDate].date.split("-");
    //         $scope.getDateRangeOfWeek(date[0], date[1]);
    //         charPoint.label = $scope.oneWeekPoint + "";
    //         charPoint.y = charPoint.y + +data[oneDate].count;
    //         $scope.dataPoints.push(charPoint);
    //     }
    //     $scope.chartByDate.options.data[0].xValueFormatString = "";
    //     $scope.chartByDate.options.data[0].dataPoints = $scope.dataPoints;
    //     $scope.chartByDate.options.axisX.labelFormatter = "";
    //     $scope.chartByDate.render();
    // };

    $scope.getUtmChartPoints = (data, name) => {
        let oneLine = {        
            type: "spline",  
            name: name,
            visible: false,      
            dataPoints: data
        }
        $scope.chartByDate.options.data.push(oneLine);
    }


//createWeekChart
    $scope.oneWeekPoint;
    Date.prototype.getWeek = function() {
        var date = new Date(this.getTime());
        date.setHours(0, 0, 0, 0);
        date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
        var week1 = new Date(date.getFullYear(), 0, 4);
        return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
    }
    $scope.getDateRangeOfWeek = (weekNo, y) => {
        var d1, numOfdaysPastSinceLastMonday, rangeIsFrom, rangeIsTo;
        d1 = new Date(''+y+'');
        numOfdaysPastSinceLastMonday = d1.getDay() - 1;
        d1.setDate(d1.getDate() - numOfdaysPastSinceLastMonday);
        d1.setDate(d1.getDate() + (7 * (weekNo - d1.getWeek())));
        rangeIsFrom = d1.getDate() + "-" + (d1.getMonth() + 1) + "-" + d1.getFullYear();
        d1.setDate(d1.getDate() + 6);
        rangeIsTo = d1.getDate() + "-" + (d1.getMonth() + 1) + "-" + d1.getFullYear() ;
        $scope.oneWeekPoint = rangeIsFrom + " do " + rangeIsTo
        return rangeIsFrom
    }
    $scope.notUniqueTotal = 0;
    $scope.createWeekChart = (data) => {
        $scope.total = 0;
        const distinctData = [...new Set(data.map(element => element.date))];
        for (let i = 0; i < distinctData.length; i++) {
            let charPoint = {
                y: 0,
                allCount: 0,
            };
            for (let j = 0; j < data.length; j++) {
                if (distinctData[i] === data[j].date) {  
                    let date = data[j].date.split("-");
                    charPoint.flter = $scope.getDateRangeOfWeek(date[0], date[1]);
                    $scope.getDateRangeOfWeek(date[0], date[1])
                    charPoint.label = $scope.oneWeekPoint + "";
                    charPoint.id = data[j].date;
                    charPoint.y = charPoint.y + +data[j].count;
                    charPoint.allCount = charPoint.allCount + +data[j].allCount;
                    $scope.total += +data[j].count;
                    $scope.notUniqueTotal += +data[j].allCount;
                }
            }
            $scope.dataPoints.push(charPoint);
        }
        $scope.chartByDate.options.data[0].xValueFormatString = "";
        // $scope.chartByDate.options.axisX.interval = "";
        // $scope.chartByDate.options.axisX.intervalType = "";
        $scope.chartByDate.options.data[0].dataPoints = $scope.dataPoints;
        $scope.chartByDate.options.axisX.labelFormatter = ""
        // $scope.changeChartIntervalX();
        $scope.chartByDate.render();
    }
//end

// Post Backs
    $scope.prepareRequestData = (groupedBy = false) => {
        let dataToPass = {
            periodStart: new Date($scope.raportFilters.periodStart).getTime() / 1000 ,
            periodEnd: (new Date($scope.raportFilters.periodEnd).setHours(23,59,59,999)) / 1000,
            offerId : $scope.raportFilters.offersId
        }
        groupedBy ? dataToPass.timeUnit = $scope.raportFilters.timeUnit : "";
        return dataToPass
    }

    $scope.getPostBackDataByDate = () => {
        $scope.sendInfo("post-back-request/execute", $scope.prepareRequestData("date"), $scope.collectDataForDateTable)
    }

    $scope.getPostBackDataByOffers = () => {
        $scope.sendInfo("post-back-request/execute", $scope.prepareRequestData(), $scope.collectDataForOfferTable);
    }

    $scope.collectDataForDateTable = (resp) => {
        $scope.colectAllCpTypes(resp.data);
        $scope.fillPBTblWithEmptyData();
        for (let j = 0; j < $scope.tableData.length; j++) {
            for (let i = 0; i < resp.data.length; i++) {
                let tableEl = $scope.tableData[j];
                let respEl = resp.data[i];
                $scope.checkIfClickHasPB(tableEl, respEl, "date");
            }
        }
        $scope.pastePBDataToTable();
    }

    $scope.collectDataForOfferTable = (resp) => {
        $scope.colectAllCpTypes(resp.data);
        $scope.fillPBTblWithEmptyData();
        for (let j = 0; j < $scope.tableData.length; j++) {
            for (let i = 0; i < resp.data.length; i++) {
                let tableEl = $scope.tableData[j];
                let respEl = resp.data[i];
                $scope.checkIfClickHasPB(tableEl, respEl, "offerId");
            } 
        }
        $scope.pastePBDataToTable();
    }

    $scope.colectAllCpTypes = (resp) => {
        for(var j = 0; j < resp.length; j++) {
            let postBacks = resp[j].postBack;
            for (var key in postBacks) {
                if(!$scope.cpTypes.includes(key)) {
                    $scope.cpTypes.push(key);
                    $("#cpValues").append('<th rowspan="1" class="cp-values">Konwersje</th><th class="cp-values" rowspan="1">Prowizja do splaty</th>');
                    if ($scope.groupedBy == "offer" || ($scope.groupedBy == "date" && $scope.raportFilters.timeUnit == "month")) {
                        $scope.showConvRange = true;
                    }
                }
            }
        }
    }

    $scope.fillPBTblWithEmptyData = () => {
        for (let k = 0; k < $scope.cpTypes.length; k++) {
            for (let j = 0; j < $scope.tableData.length; j++) {
                $scope.tableData[j][$scope.cpTypes[k]] = {conversion: "-", commission: "-"};
            }
        }
    }
        
    $scope.checkIfClickHasPB = (tableEl, respEl, param) => {
        if (tableEl.id == respEl[param]) {
            $scope.pasteConvRange(respEl, param)
            for (let k = 0; k < $scope.cpTypes.length; k++) {
                let postBacks = respEl.postBack;
                for (var key in postBacks) {
                    if ($scope.cpTypes[k] == key) {
                    tableEl[key] = respEl.postBack[key];
                    }
                }
            }
        } else if (!($scope.tableData.some(e => e.id === respEl.date)) && param == "date") {
            let oneTblEl = {};
            oneTblEl.id = respEl.date;
            oneTblEl.filterDate = new Date(respEl.date);
            oneTblEl.label = $scope.convertDate(respEl.date, "-");
            oneTblEl.allCount = "-";
            oneTblEl.y = "-";
            for (let k = 0; k < $scope.cpTypes.length; k++) {
                oneTblEl[$scope.cpTypes[k]] = {conversion: "-", commission: "-"};
                for (var key in respEl.postBack) {
                    if ($scope.cpTypes[k] == key) {
                        oneTblEl[key] = respEl.postBack[key];
                    }
                }
            }
            $scope.tableData.push(oneTblEl);
            $scope.pasteConvRange(respEl, param)
        }
    }

    $scope.pastePBDataToTable = () => {
        $(document).ready(function() {
            for (let k = 0; k < $scope.cpTypes.length; k++) {
                for (let j = 0; j < $scope.tableData.length; j++) {
                    $(`#${$scope.tableData[j].id} > .conv-range`).before(`<td>${$scope.tableData[j][$scope.cpTypes[k]].conversion}</td>
                                                                        <td>${$scope.tableData[j][$scope.cpTypes[k]].commission}</td>`);
                }
            }
        });
    }

    $scope.pasteConvRange = (element, param) => {
        $(document).ready(function() {
            if (element.conversionRange || element.conversionRange == 0) {
                $(`#${element[param]} > .conv-range`).append(`${+element.conversionRange.toFixed(2)}`);
            } else {
                let convRateDate = element.CPCount / $(`#${element[param]} > .uniqueClicks`).html() * 100;
                $(`#${element[param]} > .conv-range`).append(`${convRateDate.toFixed(2)}`);
            }
        });
    }

    $scope.setDefaultTable = () => {
        $scope.cpTypes = [];
        $(".cp-values").remove();
        $scope.showConvRange = false;
    }

    $scope.getPBData = () => {
        $scope.sendInfo("post-back-request/raport", $scope.prepareRequestData(), $scope.createPostBackTbl);
    }

    $scope.createPostBackTbl = (resp) => {
        $scope.totalComission = 0;
        $scope.collectAllRepModels(resp.data);
        $scope.postBackTbl = resp.data;
        for (let i = 0; i < $scope.postBackTbl.length; i++) {
            $scope.postBackTbl[i].clickDate = $scope.transformDate($scope.postBackTbl[i].clickDate);
            $scope.postBackTbl[i].postBackDate = $scope.transformDate($scope.postBackTbl[i].postBackDate);
            $scope.totalComission += +$scope.postBackTbl[i].commission;
            $scope.postBackTbl[i].commission = Number($scope.postBackTbl[i].commission);
        }
        $scope.saveFilterParamToTable($scope.postBackTbl, "/", "clickDate")
    }

    $scope.collectAllRepModels = (data) => {
        data.forEach((element) => {
            if (!$scope.AllRepModels.includes(element.paymentModel)) {
                $scope.AllRepModels.push(element.paymentModel);
            }
        })
    }

    $scope.filterRepModels = () => {
        if ($scope.selectedRepModel == "selectAll") {
            $scope.AllRepModels.forEach((element) => {
                let tr = $(`.post-back-table .${element}`).parent();
                tr.show();
            })
        } else {
            $scope.AllRepModels.forEach((element) => {
                if (!(element == $scope.selectedRepModel)) {
                    let tr = $(`.post-back-table .${element}`).parent();
                    tr.hide();
                } else {
                    let tr = $(`.post-back-table .${element}`).parent();
                    tr.show();
                }
            })
        }
    }

    $scope.transformDate = (date) => {
        return new Date(date * 1000).toLocaleDateString('en-GB');
    }

//End

    $scope.filterTable = (table = $scope.tableData, filterParametr = null, param = 'y') => {
        if(filterParametr === "offer") {
            if (!$scope.tableFilteredByLabel) {
                $scope.tableFilteredByLabel = true;
                table.sort(function(a, b){
                    if(a.label < b.label) { return -1; }
                    if(b.label < a.label) { return 1; }
                    else {return 0;}
                });
                
            } else if ($scope.tableFilteredByLabel) {
                $scope.tableFilteredByLabel = false;
                table.sort(function(a, b){
                    if(b.label < a.label) { return -1;}
                    if(a.label < b.label) { return 1; }
                    else {return 0;}
                });
            } 
        } else if (filterParametr ===  "date") {
            let filParam;
            $scope.raportFilters.timeUnit == "month" ? filParam = "x" : filParam = "filterDate"
            if (!$scope.tableFilteredByLabel) {
                $scope.tableFilteredByLabel = true;
                table.sort(function(a, b){return b[filParam] - a[filParam]});
            } else if ($scope.tableFilteredByLabel) {
                $scope.tableFilteredByLabel = false;
                table.sort(function(a, b){return a[filParam] - b[filParam]});
            } 
        } else {
            if (!$scope.tableFilteredByOutcklicks) {
                $scope.tableFilteredByOutcklicks = true;
                table.sort(function(a, b){return b[param] - a[param]});
                
            } else if ($scope.tableFilteredByOutcklicks) {
                $scope.tableFilteredByOutcklicks = false;
                table.sort(function(a, b){return a[param] - b[param]});
            } 
        }
    }

    $scope.changeDisplayedChart = (show, hide) => {
        show.style.display = "block";
        hide.style.display = "none";
    }

    $scope.setWidthToReportsCtn = (visibleChart) => {   
        let blockWidth = $(".office__view--partner-raport").width() + 2;
        $(".reports-ctn").width(blockWidth); 
        visibleChart.width(blockWidth);
    }

    $scope.sendInfo = (apiUrl, dataToPass, successFunction) => {

        $scope.sendXHR({
          url: `/rest/partners-analytic/${apiUrl}`,
          data: dataToPass,
          successFunc: successFunction,
          errorFunc: $scope.reportFail,
        });
    }
    $scope.reportFail = () => {
        $scope.showAlert('error', 'Fail')
    };


    $scope.getProducts = (resp) => {
        $scope.products = resp.data;
    }
    
    $scope.getOffers = (resp) => {
        $scope.offers = resp.data;
        $scope.raportFilters.offersId = [];
        $scope.offers.forEach(function(element){
            $scope.raportFilters.offersId.push(element._id)
        })
        $scope.allOffersIds = $scope.raportFilters.offersId;
        $scope.getAnalyticData();
    }

    $scope.setOfferId = () => {
        if ($scope.offerId === "selectAllProducts") {
            $scope.raportFilters.offersId = $scope.allOffersIds;
        } else {
            $scope.raportFilters.offersId = [];
            $scope.raportFilters.offersId.push($scope.offerId);
        }
        $scope.getAnalyticData();
    }

    $scope.getAnalyticData = () => {
        $scope.notUniqueTotal = 0;
        $scope.chartByDate.options.toolTip.content = "";
        $scope.dataForXMLExport = [];
        if ($scope.raportFilters.offersId.length) {
            $scope.partnerHasOffers = true;
            if ($scope.groupedBy === "post-back") {
                $scope.getPBData();
            } else {
                $scope.setDefaultTable();
                $scope.chartByDate.options.data = $scope.chartByDate.options.data.slice(0, 1);
                if ($scope.trafficSource === "racoonWebSite") {
                    $scope.getRacoonLinksData();
                }
            }
        } else {
            $scope.partnerHasOffers = false;
        }
        if ($scope.trafficSource === "referral") {
            ($scope.raportFilters.timeUnit === "week") || ($scope.raportFilters.timeUnit === "month") ? $scope.raportFilters.timeUnit = "day" : ""
            $scope.chartByDate.options.data = $scope.chartByDate.options.data.slice(0, 1);
            $scope.getReferralData();
            ($scope.groupedBy === "offer") || ($scope.groupedBy === "post-back") ? $scope.groupedBy = "date" : ""

        }
    }

    $scope.getRacoonLinksData = () => {
        $scope.sendInfo("analytic-request", $scope.raportFilters, $scope.createChart)
    }

    document.getElementById("partner-report").onclick = () => {
        $scope.setCurrentDate();
        $scope.setThisMonth();
        $scope.genereteDate();
        $scope.raportFilters.id = document.getElementsByClassName("office__view--partner-raport")[0].id;
        if ($scope.trafficSource === "racoonWebSite") {
            $scope.sendInfo("products-request", {"id": $scope.raportFilters.id}, $scope.getProducts);
            $scope.sendInfo("offers-request", {"id": $scope.raportFilters.id,"attributes": $scope.raportFilters.attributes}, $scope.getOffers);
        } else {
            $scope.getAnalyticData();
        }
        document.getElementById("export-file").onclick = () => {
            if ($scope.trafficSource === "racoonWebSite") {
                if ($scope.groupedBy === "date" || $scope.groupedBy === "offer") {
                    $scope.tableToExcel('analytic-table','Analytic-table', 'racoon-analytic-data.xls', 'clone-analytic-table-ctn');
                } else if ($scope.groupedBy === "post-back") {
                    $scope.tableToExcel('post-back-table','PostBack-table', 'racoon-post-back-data.xls', 'post-back-clone-ctn');
                }
            } else if ($scope.trafficSource === "referral") {
                $scope.tableToExcel('referral-table','Referrral-table', 'racoon-referral-data.xls', 'referral-clone-ctn');
            }
        }
        
    }

    // table to excel
    $scope.tableToExcel = (() => {
		var uri = 'data:application/vnd.ms-excel;base64,'
		, template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body><table>{table}</table></body></html>'
		, base64 = function(s) { return window.btoa(unescape(encodeURIComponent(s))) }
		, format = function(s, c) {
			return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; })
		}
		, downloadURI = function(uri, name) {
		    var link = document.createElement("a");
		    link.download = name;
		    link.href = uri;
		    link.click();
		}

		return function(table, name, fileName, clonCtnId) {
            if (!table.nodeType) {
                table = document.getElementById(table)
                let cloneTable = table.cloneNode(true);
                cloneTable.id = "clone-table";
                document.getElementById(clonCtnId).appendChild(cloneTable);
                $("#clone-table .partnerData_tip-wrp").remove();
                $scope.groupedBy === "offer" ? $("#clone-table .dateGrouped").remove() : "";
                if ($scope.groupedBy === "date") {
                    $("#clone-table .offerGrouped").remove();
                    if ($scope.raportFilters.timeUnit !== "month") {
                        $("#clone-table .conv-range-head").remove();
                        $("#clone-table .conv-range").remove();
                    }
                }
                var ctx = {worksheet: name || 'Worksheet', table: cloneTable.innerHTML};
                var resuri = uri + base64(format(template, ctx));
                downloadURI(resuri, fileName);
            }
		}
    })();
}])


// WEBPACK FOOTER //
// src/js/controllers/partner/report/reportCtrl.js